// Public frontend routes that do NOT require an authenticated session.
// Centralized here so session/auth logic stays in sync. Previously this list was
// duplicated inline in context/AuthContext.js and services/api.js, where it had
// already drifted. Matching is substring-based (pathname.includes(p)).
//
// Note: services/api.js additionally treats '/login' as public (to avoid a
// redirect loop on session-expiry) by composing ['/login', ...PUBLIC_PATHS];
// AuthContext intentionally does not skip the auth check on '/login'.
export const PUBLIC_PATHS = [
  '/signup',
  '/sign/',
  '/staging/',
  '/portal/',
  '/accept-invite/',
  '/discovery/download/',
  '/intake/form/',
  '/intake/start',
  '/appointments/respond/',
  '/visage/guest',
  '/payment-success',  // 2026-10-16: Square redirect target; was bouncing clients to staff login
];
